export const loadCittaComuniOptions = async () => {
  const res = await fetch('/comuni.json')
  const comuniData = await res.json()

  return comuniData.map((comune) => ({
    label: comune.nome,
    value: `${comune.nome}|${comune.sigla}`,
  }))
}

export const statoOptions = [{ label: 'Italia', value: 'it' }]
